module.exports = __webpack_public_path__ + "img/Mask group@2x.8b9f5148.png";